export const costValueFormat = (costValue: number) =>
  `€ ${costValue.toFixed(2).replace(".", ",")}`;
